import styled from "styled-components";
import ty from "../styled-tachyons";
import { lQuery, rem, WhiteSection, StyledLink } from "../styles";

export const ArtistTag = styled(StyledLink).attrs({
  className: "no-link-style no-inherit",
})`
  ${ty`f4 fw8 ttu dib no-underline ph3 pv1`}
  &,&:visited {
    ${ty`near-black`}
  }
  font-family: prompt, sans-serif;
`;
export const ArtistTagsContainer = styled.div.attrs({
  className: "no-inherit",
})`
  min-height: ${rem(315)};
  position: relative;
`;
export const ArtistTags = styled.div`
  ${ty`flex flex-column items-start justify-between`}
  ${ty`ph2 mw6 center pt4`}
  ${lQuery} {
    width: ${rem(315)};
    ${({ numItems }) => {
      let max = rem(1073);
      if (!numItems || numItems >= 6) {
        return { maxHeight: max, minHeight: rem(793) };
      } else {
        return { maxHeight: rem(numItems * 100), height: "100%" };
      }
    }};
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%) rotate(-90deg);
  }
  /* outline: thin solid green; */
  ${ArtistTag} {
    transition: margin 0.25s ease-out;
    max-width: 90%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    ${ty`mb3 mb0-l`}
    &:nth-child(2n + 1) {
      &:hover {
        ${ty`ml3`}
      }
    }

    &:nth-child(2n + 2) {
      ${ty`self-end`}
      &:hover {
        ${ty`mr3`}
      }
    }

    &:nth-child(3n + 1) {
      &,&:visited {
        ${ty`white`}
      }
      background-color: #FF0000;
    }
    &:nth-child(3n + 2) {
      ${ty`bg-white`}
    }

    ${WhiteSection} &:nth-child(3n + 2) {
      ${ty`bg-near-black white`}
    }

    &:nth-child(3n + 3) {
      ${ty`bg-washed-red`}
    }
  }
`;
